import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../shared/Utility';
import initialState from './initialState';

export const setSentenceList = (state, action) => {
  return (
    updateObject(state, {
        sentenceList: action.data,
    })
  )
};

const testReducer = (state = initialState.test, action) => {
  switch (action.type) {
    case actionTypes.SET_SENTENCE_LIST: return setSentenceList(state, action);
    default:
      return state;
  }
};

export default testReducer;
